import React from "react";

interface EmptyInboxProps {
  title?: string;
  subtitle?: string;
  width?: number | string;
  height?: number | string;
}

const EmptyInbox: React.FC<EmptyInboxProps> = ({
  title = "Your inbox is empty",
  subtitle = "No new messages to show",
  width = "100%",
  height = "auto",
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0 }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 680 320"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={title}
      >
        <title>{title}</title>
        <desc>An illustration of an empty email inbox with an open envelope and floating paper plane</desc>

        <rect x="190" y="60" width="300" height="190" rx="14" fill="#e8e4f8" />
        <rect x="190" y="60" width="300" height="190" rx="14" fill="none" stroke="#c4baf0" strokeWidth="1.5" />

        <polygon points="190,74 340,170 490,74" fill="#d4cef5" />
        <polygon points="190,74 340,170 490,74" fill="none" stroke="#b8b0e8" strokeWidth="1.2" />

        <rect x="222" y="85" width="236" height="145" rx="6" fill="#ffffff" stroke="#d0cbe8" strokeWidth="1" />
        <line
          x1="248"
          y1="125"
          x2="432"
          y2="125"
          stroke="#c4baf0"
          strokeWidth="2.5"
          strokeLinecap="round"
          opacity="0.5"
        />
        <line
          x1="248"
          y1="143"
          x2="432"
          y2="143"
          stroke="#c4baf0"
          strokeWidth="2.5"
          strokeLinecap="round"
          opacity="0.35"
        />
        <line
          x1="248"
          y1="161"
          x2="380"
          y2="161"
          stroke="#c4baf0"
          strokeWidth="2.5"
          strokeLinecap="round"
          opacity="0.25"
        />

        <g transform="translate(398, 22) rotate(-22)">
          <polygon points="0,0 38,14 0,28" fill="#7c6fcd" />
          <polygon points="0,14 18,14 38,14 22,28 0,28" fill="#a99ee0" opacity="0.7" />
          <line x1="0" y1="14" x2="38" y2="14" stroke="#ffffff" strokeWidth="1" opacity="0.6" />
        </g>

        <circle cx="168" cy="95" r="4" fill="#c4baf0" opacity="0.5" />
        <circle cx="155" cy="112" r="2.5" fill="#c4baf0" opacity="0.35" />
        <circle cx="174" cy="126" r="1.8" fill="#c4baf0" opacity="0.25" />

        <circle cx="514" cy="168" r="4" fill="#c4baf0" opacity="0.5" />
        <circle cx="528" cy="153" r="2.5" fill="#c4baf0" opacity="0.35" />
        <circle cx="520" cy="184" r="1.8" fill="#c4baf0" opacity="0.25" />

        <path d="M450 35 L452 41 L458 43 L452 45 L450 51 L448 45 L442 43 L448 41 Z" fill="#a99ee0" opacity="0.55" />
        <path
          d="M218 35 L219.5 39 L224 40.5 L219.5 42 L218 46 L216.5 42 L212 40.5 L216.5 39 Z"
          fill="#a99ee0"
          opacity="0.4"
        />
      </svg>

      {(title || subtitle) && (
        <div style={{ textAlign: "center", marginTop: 8 }}>
          {title && (
            <p style={{ margin: 0, fontSize: 15, color: "var(--color-text-secondary, #888)", fontWeight: 400 }}>
              {title}
            </p>
          )}
          {subtitle && (
            <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--color-text-tertiary, #aaa)", fontWeight: 400 }}>
              {subtitle}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default EmptyInbox;
